/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterAzureApplication extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterAzureApplication");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterAzureApplication.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterAzureApplication>): ServiceAccountCredentialsForKubernetesClusterAzureApplication {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterAzureApplication(), model);
        ServiceAccountCredentialsForKubernetesClusterAzureApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterAzureApplication>): ServiceAccountCredentialsForKubernetesClusterAzureApplication {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterAzureApplication.newInstance(<ServiceAccountCredentialsForKubernetesClusterAzureApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAzureApplication) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterAzureApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAzureApplication): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterAzureApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

    /**
     * Subscription Id. This is a required field.
     */
    subscription_id: string;

}
